import { render, staticRenderFns } from "./Taxreport.vue?vue&type=template&id=3c55d654&"
import script from "./Taxreport.vue?vue&type=script&lang=js&"
export * from "./Taxreport.vue?vue&type=script&lang=js&"
import style0 from "./Taxreport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports